// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2720%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M7 10l5 5 5-5z%27 fill=%27%2300A3FF%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./interface/icons/loading.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./interface/icons/playing.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./interface/icons/translate.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --tsplayer-font-family: 'Poppins', sans-serif;
}

.tsplayer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}

.tsplayer-modal {
  position: relative;
  width: 532px;
  max-width: 90%;
  background-color: white;
  border-radius: 24px;
  gap: 16px;
  opacity: 1;
  transition: all 0.3s ease;
  overflow-y: auto;
  margin-right: 20px;
  margin-bottom: 20px;
  max-height: 90vh;
}

@media (max-width: 768px) {
  .tsplayer-modal {
    width: 100%;
    max-height: 100%;
    border-radius: 0px;
    margin-right: 0px;
  }
}

.tsplayer-content {
  padding: 16px;
}

.tsplayer-content-mini {
  padding: 8px 16px !important;
}

.tsplayer-player-header {
  text-align: center;
  padding: 1rem;
  cursor: move;
}

.header-mini {
  padding: 0rem;
}

.tsplayer-player-header-btns {
  position: absolute;
  top: 32px;
  right: 20px;
  display: flex;
}

.tsplayer-btns-mini {
  top: 8px;
}

.tsplayer-player-body {
  border: 1px solid #00000014;
  border-radius: 16px;
  min-height: 55vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 5rem;
}

.tsplayer-player-body-content {
  border: 1px solid #00000014;
  border-radius: 16px;
  min-height: 55vh;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  padding: 1rem;
  justify-content: center;
}

.tsplayer-player-body-content-mini {
  border: 1px solid #00000014;
  border-radius: 16px;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  text-wrap: nowrap;
}

.tsplayer-player-player {
  padding: 5px 0px;
}

.tsplayer-icon-button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 2px;
  border-radius: 50%;
  transition: background-color 0.3s ease, transform 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tsplayer-icon-button:hover {
  background-color: rgba(0, 0, 0, 0.1);
  transform: scale(1.1);
}

.tsplayer-icon-button:active {
  transform: scale(0.9);
}

.tsplayer-title {
  font-family: var(--tsplayer-font-family);
  font-size: 22.5px;
  font-weight: 500;
  line-height: 33.75px;
  text-align: center;
}

.tsplayer-title2 {
  font-family: var(--tsplayer-font-family);
  font-size: 18.5px;
  font-weight: 500;
  line-height: 27.75px;
  text-align: center;
  color: #454957;
}

.tsplayer-title3 {
  font-family: var(--tsplayer-font-family);
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  text-align: center;
  color: #666;
}

/* SELECT STYLES */

.tsplayer-player-options {
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.tsplayer-player-options-item {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.tsplayer-player-options label {
  font-size: 16px;
  color: #333;
  margin-bottom: 8px;
}

.tsplayer-player-options select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #fff;
  font-size: 16px;
  color: #333;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  appearance: none;
}

.tsplayer-player-options select:hover {
  border-color: #007bff;
}

.tsplayer-player-options select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.tsplayer-player-options select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 20px;
}

.tsplayer-player-options select:disabled {
  background-color: #f5f5f5;
  color: #999;
  border-color: #ddd;
  cursor: not-allowed;
  background-image: none;
}

.tsplayer-player-selected-text {
  font-family: var(--tsplayer-font-family);
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  text-align: left;
}

.tsplayer-player-selected-wrapper {
  padding: 8px;
  border-radius: 4px;
  background: #2ab1eb1a;
  width: 100%;
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}

.tsplayer-player-selected-wrapper-mini {
  padding: 2px;
  border-radius: 4px;
  background: #2ab1eb1a;
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  text-overflow: ellipsis;
}

.icon-wrap-mini {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ts-widget-chat-bubble {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  background-color: #f1f1f1;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  padding: 10px;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.ts-widget-chat-bubble:hover {
  transform: scale(1.1);
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
}

.ts-widget-chat-bubble:active {
  transform: scale(0.95);
}

.ts-img-loading {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  width: 35px;
}

.ts-img-playing {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  width: 35px;
}

.ts-img-translate {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  margin-right: 5px;
}

.ts-speed-player-btn {
  background-image: none;
  background-color: #ddd;
  padding: 4px;
  border-radius: 6px;
  font-size: 10px;
  margin: 1px;
  min-width: 30px;
  border: 1px solid #ccc;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.ts-speed-player-btn-active {
  background-image: none;
  padding: 4px;
  border-radius: 6px;
  font-size: 10px;
  margin: 1px;
  min-width: 30px;
  border: 1px solid #ccc;

  background-color: #bbb;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}

.ts-speed-player-btn:hover {
  background-color: #bbb;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}

.ts-speed-player-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.ts-speed-player-btn:disabled {
  background-color: #f5f5f5;
  border-color: #ddd;
  color: #aaa;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
  transition: none;
}
`, "",{"version":3,"sources":["webpack://./src/presentation/components/TS-widget/ts-styles.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,2DAA2D;EAC3D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA,kBAAkB;;AAElB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,wDAAwD;EACxD,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,yDAA4L;EAC5L,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gDAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,gDAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,gDAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,eAAe;EACf,sBAAsB;;EAEtB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[":root {\n  --tsplayer-font-family: 'Poppins', sans-serif;\n}\n\n.tsplayer-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n}\n\n.tsplayer-modal {\n  position: relative;\n  width: 532px;\n  max-width: 90%;\n  background-color: white;\n  border-radius: 24px;\n  gap: 16px;\n  opacity: 1;\n  transition: all 0.3s ease;\n  overflow-y: auto;\n  margin-right: 20px;\n  margin-bottom: 20px;\n  max-height: 90vh;\n}\n\n@media (max-width: 768px) {\n  .tsplayer-modal {\n    width: 100%;\n    max-height: 100%;\n    border-radius: 0px;\n    margin-right: 0px;\n  }\n}\n\n.tsplayer-content {\n  padding: 16px;\n}\n\n.tsplayer-content-mini {\n  padding: 8px 16px !important;\n}\n\n.tsplayer-player-header {\n  text-align: center;\n  padding: 1rem;\n  cursor: move;\n}\n\n.header-mini {\n  padding: 0rem;\n}\n\n.tsplayer-player-header-btns {\n  position: absolute;\n  top: 32px;\n  right: 20px;\n  display: flex;\n}\n\n.tsplayer-btns-mini {\n  top: 8px;\n}\n\n.tsplayer-player-body {\n  border: 1px solid #00000014;\n  border-radius: 16px;\n  min-height: 55vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 1rem 5rem;\n}\n\n.tsplayer-player-body-content {\n  border: 1px solid #00000014;\n  border-radius: 16px;\n  min-height: 55vh;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: row;\n  padding: 1rem;\n  justify-content: center;\n}\n\n.tsplayer-player-body-content-mini {\n  border: 1px solid #00000014;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: center;\n  text-wrap: nowrap;\n}\n\n.tsplayer-player-player {\n  padding: 5px 0px;\n}\n\n.tsplayer-icon-button {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 2px;\n  border-radius: 50%;\n  transition: background-color 0.3s ease, transform 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.tsplayer-icon-button:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n  transform: scale(1.1);\n}\n\n.tsplayer-icon-button:active {\n  transform: scale(0.9);\n}\n\n.tsplayer-title {\n  font-family: var(--tsplayer-font-family);\n  font-size: 22.5px;\n  font-weight: 500;\n  line-height: 33.75px;\n  text-align: center;\n}\n\n.tsplayer-title2 {\n  font-family: var(--tsplayer-font-family);\n  font-size: 18.5px;\n  font-weight: 500;\n  line-height: 27.75px;\n  text-align: center;\n  color: #454957;\n}\n\n.tsplayer-title3 {\n  font-family: var(--tsplayer-font-family);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  text-align: center;\n  color: #666;\n}\n\n/* SELECT STYLES */\n\n.tsplayer-player-options {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.tsplayer-player-options-item {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.tsplayer-player-options label {\n  font-size: 16px;\n  color: #333;\n  margin-bottom: 8px;\n}\n\n.tsplayer-player-options select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  background-color: #fff;\n  font-size: 16px;\n  color: #333;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n  appearance: none;\n}\n\n.tsplayer-player-options select:hover {\n  border-color: #007bff;\n}\n\n.tsplayer-player-options select:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\n}\n\n.tsplayer-player-options select {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24'%3E%3Cpath d='M7 10l5 5 5-5z' fill='%2300A3FF'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 20px;\n}\n\n.tsplayer-player-options select:disabled {\n  background-color: #f5f5f5;\n  color: #999;\n  border-color: #ddd;\n  cursor: not-allowed;\n  background-image: none;\n}\n\n.tsplayer-player-selected-text {\n  font-family: var(--tsplayer-font-family);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  text-align: left;\n}\n\n.tsplayer-player-selected-wrapper {\n  padding: 8px;\n  border-radius: 4px;\n  background: #2ab1eb1a;\n  width: 100%;\n  display: flex;\n  gap: 0.5rem;\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.tsplayer-player-selected-wrapper-mini {\n  padding: 2px;\n  border-radius: 4px;\n  background: #2ab1eb1a;\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.icon-wrap-mini {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ts-widget-chat-bubble {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  width: 60px;\n  height: 60px;\n  background-color: #f1f1f1;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  padding: 10px;\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.ts-widget-chat-bubble:hover {\n  transform: scale(1.1);\n  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);\n}\n\n.ts-widget-chat-bubble:active {\n  transform: scale(0.95);\n}\n\n.ts-img-loading {\n  content: url('./interface/icons/loading.gif');\n  width: 35px;\n}\n\n.ts-img-playing {\n  content: url('./interface/icons/playing.gif');\n  width: 35px;\n}\n\n.ts-img-translate {\n  content: url('./interface/icons/translate.png');\n  margin-right: 5px;\n}\n\n.ts-speed-player-btn {\n  background-image: none;\n  background-color: #ddd;\n  padding: 4px;\n  border-radius: 6px;\n  font-size: 10px;\n  margin: 1px;\n  min-width: 30px;\n  border: 1px solid #ccc;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n.ts-speed-player-btn-active {\n  background-image: none;\n  padding: 4px;\n  border-radius: 6px;\n  font-size: 10px;\n  margin: 1px;\n  min-width: 30px;\n  border: 1px solid #ccc;\n\n  background-color: #bbb;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n}\n\n.ts-speed-player-btn:hover {\n  background-color: #bbb;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n}\n\n.ts-speed-player-btn:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.ts-speed-player-btn:disabled {\n  background-color: #f5f5f5;\n  border-color: #ddd;\n  color: #aaa;\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n  transition: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
